webpackJsonp([162898551421021],{

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helmetBuilder = __webpack_require__(19);
	
	var _helmetBuilder2 = _interopRequireDefault(_helmetBuilder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageNotFound = function (_React$Component) {
	  _inherits(PageNotFound, _React$Component);
	
	  function PageNotFound(props) {
	    _classCallCheck(this, PageNotFound);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  PageNotFound.prototype.componentDidMount = function componentDidMount() {
	    var header = document.getElementsByClassName('header')[0];
	    if (header) {
	      header.classList.add('header__black');
	    }
	  };
	
	  PageNotFound.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'terms' },
	      _react2.default.createElement(_helmetBuilder2.default, {
	        data: { title: "Page Not Found - The Farm Project" }
	      }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h1',
	        { style: { textAlign: 'center' } },
	        'Oops! That page can\'t be found.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null)
	    );
	  };
	
	  return PageNotFound;
	}(_react2.default.Component);
	
	exports.default = PageNotFound;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-0144c9a39856974eece1.js